/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OIDCTokensInfo } from './OIDCTokensInfo';
import {
    OIDCTokensInfoFromJSON,
    OIDCTokensInfoFromJSONTyped,
    OIDCTokensInfoToJSON,
} from './OIDCTokensInfo';

/**
 * 
 * @export
 * @interface TokenContainer
 */
export interface TokenContainer {
    /**
     * 
     * @type {string}
     * @memberof TokenContainer
     */
    aud?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenContainer
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof TokenContainer
     */
    iat?: number;
    /**
     * 
     * @type {number}
     * @memberof TokenContainer
     */
    exp?: number;
    /**
     * 
     * @type {number}
     * @memberof TokenContainer
     */
    nbf?: number;
    /**
     * 
     * @type {string}
     * @memberof TokenContainer
     */
    iss?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenContainer
     */
    sub?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenContainer
     */
    user_token: string;
    /**
     * 
     * @type {Array<OIDCTokensInfo>}
     * @memberof TokenContainer
     */
    oidc_tokens?: Array<OIDCTokensInfo>;
}

/**
 * Check if a given object implements the TokenContainer interface.
 */
export function instanceOfTokenContainer(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "user_token" in value;

    return isInstance;
}

export function TokenContainerFromJSON(json: any): TokenContainer {
    return TokenContainerFromJSONTyped(json, false);
}

export function TokenContainerFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenContainer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'aud': !exists(json, 'aud') ? undefined : json['aud'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'iat': !exists(json, 'iat') ? undefined : json['iat'],
        'exp': !exists(json, 'exp') ? undefined : json['exp'],
        'nbf': !exists(json, 'nbf') ? undefined : json['nbf'],
        'iss': !exists(json, 'iss') ? undefined : json['iss'],
        'sub': !exists(json, 'sub') ? undefined : json['sub'],
        'user_token': json['user_token'],
        'oidc_tokens': !exists(json, 'oidc_tokens') ? undefined : ((json['oidc_tokens'] as Array<any>).map(OIDCTokensInfoFromJSON)),
    };
}

export function TokenContainerToJSON(value?: TokenContainer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'aud': value.aud,
        'id': value.id,
        'iat': value.iat,
        'exp': value.exp,
        'nbf': value.nbf,
        'iss': value.iss,
        'sub': value.sub,
        'user_token': value.user_token,
        'oidc_tokens': value.oidc_tokens === undefined ? undefined : ((value.oidc_tokens as Array<any>).map(OIDCTokensInfoToJSON)),
    };
}

